var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcWelfare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10564",
    "data-name": "Group 10564",
    transform: "translate(-1065 -1496)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17830",
    "data-name": "Rectangle 17830",
    width: 40,
    height: 40,
    transform: "translate(1065 1496)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-md-happy",
    "data-name": "Icon ionic-md-happy",
    d: "M22.2,3.375A18.824,18.824,0,1,0,41.023,22.2,18.819,18.819,0,0,0,22.2,3.375Zm0,33.884A15.059,15.059,0,1,1,37.259,22.2,15.1,15.1,0,0,1,22.2,37.259Zm6.588-16.942a2.824,2.824,0,1,0-2.824-2.824A2.773,2.773,0,0,0,28.788,20.317Zm-13.177,0a2.824,2.824,0,1,0-2.824-2.824A2.773,2.773,0,0,0,15.611,20.317ZM22.2,32.553a10.256,10.256,0,0,0,9.6-6.589H12.6A10.256,10.256,0,0,0,22.2,32.553Z",
    transform: "translate(1062.801 1493.801)",
    fill: "#fff"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcWelfare);
export default __webpack_public_path__ + "static/media/ic_welfare.5b7499ab10c6c869f74999fe715182fb.svg";
export { ForwardRef as ReactComponent };